import '../../../css/web/UserModalRenew.css'
import useTheme from '../layoutscommon/DarkModeStorage'
import React, {useEffect, useState} from "react";
import { loadPaypalScript } from '../../../services/PaypalUtils';
import '../../../css/web/PaypalModal.css'
import PaypalPaymentBt from "./PaypalPaymentBt";
import MsgConfirmModal from "./MsgConfirmModal";
import {useTranslation} from "react-i18next";
import commonClose from "../../../assets/img/commonClose.png";
import creditCard from "../../../assets/img/blueCard.png";
import MsgCheckModal from "./MsgCheckModal";
import axios from "axios";

// ▶▶ 웹 페이팔결제 API 연동프로세스(Paypal Javascript SDK)
// 1. OrderPg에서 페이팔 선택하여 PaypalModal 팝업오픈
// 2. 오픈 후 currency값 업데이트 시(페이팔 결제버튼 클릭 시) useEffect을 통해 값 전달과 함께 loadPaypalScript(PaypalUtils.js) 실행
// 3. loadPaypalScript(PaypalUtils.js)가 실행되면 페이팔팝업이 나타나서 카드번호입력 또는 페이팔계정으로 결제처리
// 4. 결제완료 후 scriptLoaded가 true로 되면서 PaypalPaymentBt.js의 함수가 실행되어 페이팔 측 응답값을 processAfterPaypal(state, orderId)로 반환
// 5. 반환값이 "COMPLETED"면 OrderPg의 afterOrderProcess()를 실행하고 백엔드로 COMPLETE를 전달하여 OS/IS 결제완료처리
// 6. 반환값이 "PENDING"이면 OrderPg의 afterOrderProcess()를 실행하고 백엔드로 PENDING을 전달하여 OS/IS 결제중처리
// 7. PENDING 상태는 추후에 페이팔이 COMPLETED로 업데이트되면 백엔드의 PaypalWebhook.handlePaypalWebhook메서드가 호출되고 결제내역의 ConfirmPay() 실행하여 OS/IS 결제완료처리

function PaypalModal({paypalPopupClose, currency, finalPayExpense, lastForPrice, afterOrderProcess, usageType, onPaidUncertain}) {
    const { t } = useTranslation();
    const [theme] = useTheme();
    const [scriptLoaded, setScriptLoaded] = useState(false);
    useEffect(() => {
        // currency 값 설정 시 PaypalUtils에 전달하여 스크립트로드
        loadPaypalScript(currency).then(() => {
            setScriptLoaded(true);
        });
    }, [currency]);

    const sendErrorLogToBackend = async (id, errorTitle, errorContent) => {
        try {
            await axios.post("/errorlog/save", {
                email: id, // ⚠️ 현재 로그인한 사용자 ID (state 변수 사용)
                title: `[Web] ${errorTitle}`,
                content: typeof errorContent === 'object' ? JSON.stringify(errorContent) : String(errorContent)
            });
        } catch (e) {
            console.error("로그 서버 전송 실패", e);
        }
    };

    const [cardNumber, setCardNumber] = useState('');
    const [exprMonth, setExprMonth] = useState('');
    const [exprYear, setExprYear] = useState('');
    const [cvv, setCvv] = useState('');
    const [name, setName] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [payErrorMsg, setPayErrorMsg] = useState(false);

    /**
     * [결제누락 개선]
     *  - PayPal 실제 거래번호(pgTid)를 상위(주문서/예치금충전 페이지)까지 전달하여
     *    주문서에 결제식별번호가 저장되도록 한다. (기존에는 전달만 하고 저장하지 않아 대사가 불가능했음)
     */
    const processAfterPaypal = ((state, orderId, pgTid) => {
        if (state === "COMPLETED" || state === "PENDING") {
            afterOrderProcess(state, orderId, "paypal", 0, pgTid);
        } else {
            setPayErrorMsg(true);
            sendErrorLogToBackend("WebUser", "Process After Paypal Failed", `State: ${state}, OrderId: ${orderId}`);
        }
    })

    /** 페이팔 SDK 오류/캡처 실패 시 사용자 안내 */
    const handlePayError = () => {
        setPayErrorMsg(true);
    };

    /**
     * [결제누락 개선] 결제여부를 알 수 없는 상태
     *  주문서 화면이면 '결제대기' 강제저장으로 넘기고 팝업을 닫는다.
     *  (예치금충전처럼 넘길 곳이 없는 화면이면 기존대로 안내문구만)
     */
    const handlePaidUncertain = async (payNum, pgTid, reason) => {
        sendErrorLogToBackend("WebUser", "Paypal 결제여부 불명", `${reason} / PayNum: ${payNum}`);
        if (onPaidUncertain) {
            await paypalPopupClose();
            onPaidUncertain(payNum, pgTid, reason);
        } else {
            setPayErrorMsg(true);
        }
    };

    const closePayErrorMsg = () => {
        setPayErrorMsg(false);
    }


    return (
        <div className="paypal-modal-container md-scope" data-theme={theme}>
            <div className="paypal-modal-frame">
                <div className="paypal-modal-scroll-area">
                    <div className="font-t-cont">
                        {/*헤더*/}
                        <div className="display-flex just-cont-fend m-b-20">
                            <img onClick={paypalPopupClose} className="c-point wd-30 ht-30 m-a-opc-06" src={commonClose}
                                 alt="close"/>
                        </div>
                        {/*바디*/}
                        <div className="paypal-modal-body-container">
                            <div className="paypal-modal-header-container">
                                <div className="paypal-modal-header-frame">
                                    <p className="paypal-modal-header-text">{t(`pmHeader1`)}</p>
                                </div>
                                <div>
                                    <img src={creditCard} className="wd-40 ht-40" alt="paypal"/>
                                </div>
                            </div>

                            <div className="paypal-modal-price-container">
                                <div className="paypal-modal-price-frame">
                                    <a className="paypal-modal-price-text1">{t(`pcWon`)}</a>
                                    <a className="paypal-modal-price-text2">{finalPayExpense && finalPayExpense.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                </div>
                                <div className="paypal-modal-price-frame">
                                    <a className="paypal-modal-price-text1">{t(`pmHeader2`)}</a>
                                    <div>
                                        <a className="paypal-modal-price-text2">{lastForPrice && lastForPrice}</a>
                                        <a className="m-l-3 font-s-12 paypal-modal-price-text1">{currency && currency}</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/*푸터*/}
                    <div className="font-t-cont m-t-20">
                        <div>
                            <div className="paypal-modal-footer-header-container">
                                <div className="paypal-modal-footer-header-frame">
                                    <p className="paypal-modal-footer-header-text">{t(`pmHeader3`)}</p></div>
                            </div>

                            <div className="wd-100pc">
                                {scriptLoaded &&
                                    /* key={currency} : 통화가 바뀌면 SDK가 재로드되므로 버튼도 새로 마운트되어야 한다 */
                                    <PaypalPaymentBt key={currency} total={lastForPrice}
                                                     processAfterPaypal={processAfterPaypal}
                                                     onPaidUncertain={handlePaidUncertain}
                                                     currency={currency}
                                                     usageType={usageType}
                                                     finalPayExpense={finalPayExpense}
                                                     onPayError={handlePayError}/>
                                }
                            </div>
                            {/*<div style={{borderBottom:"solid", borderWidth:"thin 1px", borderColor:"lightgrey", height:"30px", position:"relative"}}>*/}
                            {/*    <span style={{position:"absolute", left:"45%", top:"45%", width:"50px", height:"30px", background:"var(--md-surface, white)", textAlign:"center", fontSize:"18px", color:"var(--md-text-sub, dimgrey)"}}>or</span>*/}
                            {/*</div>*/}


                            {/*<div style={{height:"60px", marginTop:"30px"}}>*/}
                            {/*    <div className="ReviewPgSearchFrame acc-icon">*/}
                            {/*        <div className="ReviewPgInputForm" style={{width: "97%"}}>*/}
                            {/*            <input className="ReviewInput user-input"*/}
                            {/*                   style={{width: "100%", marginLeft: "10px", height: "100%", zIndex:10}}*/}
                            {/*                   type="text"*/}
                            {/*                   placeholder=""*/}
                            {/*                   maxLength={30}*/}
                            {/*                   onChange={(e)=> setCardNumber(e.target.value)}*/}
                            {/*            />*/}
                            {/*            <label className="JoinLabel" style={{fontSize: "14px"}}>Card Number</label>*/}
                            {/*            <div style={{position:"absolute", top:"1%", left:"65%", height:"100%", width:"38%",*/}
                            {/*                display:"flex", justifyContent:"flex-end", alignItems:"center"}}>*/}
                            {/*                <Image style={{width:"40px", height:"40px"}} src={visa}/>*/}
                            {/*                <Image style={{width:"40px", height:"40px", marginLeft:"5px"}} src={master}/>*/}
                            {/*                <Image style={{width:"40px", height:"40px", marginLeft:"5px"}} src={amex}/>*/}
                            {/*                <Image style={{width:"40px", height:"50px", marginLeft:"5px", marginRight:"10px"}} src={discover}/>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            {/*<div style={{height:"60px", display:"flex", justifyContent:"space-between", marginTop:"10px"}}>*/}
                            {/*    <div className="ReviewPgSearchFrame acc-icon" style={{width:"48%"}}>*/}
                            {/*        <div className="ReviewPgInputForm" style={{width: "93%"}}>*/}
                            {/*            <input className="ReviewInput user-input"*/}
                            {/*                   style={{width: "100%", marginLeft: "10px", height: "100%"}} type="text"*/}
                            {/*                   placeholder=""*/}
                            {/*                   onChange={(e)=> setExp(e.target.value)}*/}
                            {/*            />*/}
                            {/*            <label className="JoinLabel" style={{fontSize: "14px"}}>Expiration</label>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    <div className="ReviewPgSearchFrame acc-icon" style={{width:"48%", marginLeft:"10px"}}>*/}
                            {/*        <div className="ReviewPgInputForm" style={{width: "93%"}}>*/}
                            {/*            <input className="ReviewInput user-input"*/}
                            {/*                   style={{width: "100%", marginLeft: "10px", height: "100%"}} type="text"*/}
                            {/*                   placeholder=""*/}
                            {/*                   onChange={(e)=> setCvv(e.target.value)}*/}
                            {/*            />*/}
                            {/*            <label className="JoinLabel" style={{fontSize: "14px"}}>CVV</label>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            {/*<div style={{height:"60px", display:"flex", justifyContent:"space-between", marginTop:"10px"}}>*/}
                            {/*    <div className="ReviewPgSearchFrame acc-icon" style={{width:"48%"}}>*/}
                            {/*        <div className="ReviewPgInputForm" style={{width: "93%"}}>*/}
                            {/*            <input className="ReviewInput user-input"*/}
                            {/*                   style={{width: "100%", marginLeft: "10px", height: "100%"}} type="text"*/}
                            {/*                   placeholder=""*/}
                            {/*                   onChange={(e)=> setFName(e.target.value)}*/}
                            {/*            />*/}
                            {/*            <label className="JoinLabel" style={{fontSize: "14px"}}>First Name</label>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    <div className="ReviewPgSearchFrame acc-icon" style={{width:"48%", marginLeft:"10px"}}>*/}
                            {/*        <div className="ReviewPgInputForm" style={{width: "93%"}}>*/}
                            {/*            <input className="ReviewInput user-input"*/}
                            {/*                   style={{width: "100%", marginLeft: "10px", height: "100%"}} type="text"*/}
                            {/*                   placeholder=""*/}
                            {/*                   onChange={(e)=> setLName(e.target.value)}*/}
                            {/*            />*/}
                            {/*            <label className="JoinLabel" style={{fontSize: "14px"}}>Last Name</label>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            {/*<div style={{height:"60px", marginTop:"10px"}}>*/}
                            {/*    <div className="ReviewPgSearchFrame acc-icon">*/}
                            {/*        <div className="ReviewPgInputForm" style={{width: "97%"}}>*/}
                            {/*            <input className="ReviewInput user-input"*/}
                            {/*                   style={{width: "100%", marginLeft: "10px", height: "100%"}} type="text"*/}
                            {/*                   placeholder=""*/}
                            {/*                   onChange={(e)=> setBZip(e.target.value)}*/}
                            {/*            />*/}
                            {/*            <label className="JoinLabel" style={{fontSize: "14px"}}>Billing zip code</label>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}


                            {/*<div style={{height:"60px", marginTop:"30px"}}>*/}
                            {/*    <button className="orderItemHandleBt" style={{width:"100%" ,height: "50px", margin:"0", fontSize:"18px", borderRadius:"4px"}}>Payment</button>*/}
                            {/*</div>*/}


                            {/*<div style={{height:"100px", marginTop:"10px"}}>*/}
                            {/*    <div style={{fontSize:"12px", color:"var(--md-text-sub, dimgrey)"}}>※ 페이팔 개인정보 보호정책에 따라 페이팔에서 데이터를 수집/처리할 수 있습니다</div>*/}
                            {/*    /!*<div style={{fontSize:"12px", marginTop:"10px", color:"var(--md-text-sub, dimgrey)"}}>※ 위 비토리지와 연동된 페이팔을 통한 결제 시, 결제 및 기타 식별 정보 등 페이팔은 사기 탐지, 피해 및 손실 방지,*!/*/}
                            {/*    /!*    인증, 서비스 성능과 관련된 분석을 포함하여 페이팔이 제공하는 서비스 운영/개선/규정준수를 위해 해당 정보를 사용할 수 있으며,*!/*/}
                            {/*    /!*    법적 요구사항 및 해당 정보 처리 시에는 페이팔에서 규정한 개인정보취급방침이 적용됩니다.</div>*!/*/}
                            {/*</div>*/}

                        </div>
                    </div>
                </div>
            </div>


            {payErrorMsg ?
                <MsgCheckModal payErrorMsg={payErrorMsg} closePayErrorMsg={closePayErrorMsg}/>
                :
                null
            }

        </div>
    )
}

export default PaypalModal
